module.exports = __webpack_public_path__ + "static/media/psykinetic.9c1952ca.png";